import {
  SET_ORDEN,
  ESTADO_ORDEN,
  ESTADO_ORDEN_FAIL,
  ESTADO_ORDEN_SUCCESS,
  USUARIOALTA_ORDEN,
  USUARIOALTA_ORDEN_SUCCESS, USUARIOALTA_ORDEN_FAIL,
  MATCH_ORDEN_TURNO, MATCH_ORDEN_TURNO_SUCCESS, MATCH_ORDEN_TURNO_FAIL,
  ASOCIAR_ORDEN_TURNO, ASOCIAR_ORDEN_TURNO_SUCCESS, ASOCIAR_ORDEN_TURNO_FAIL
} from "../ActionTypes";
import axiosLogin from "global/helpers/axiosLogin";

export const setOrden = (orden) => (dispatch) => {
  dispatch({ type: SET_ORDEN, payload: orden });
};

export const wsGetEstadoOrden =
  (idTurno, flgTiempoEspera, nextStep) => (dispatch) => {
    dispatch({ type: ESTADO_ORDEN });

    axiosLogin().then((respuesta) => {
      respuesta
        .get(`/his/turnos/estadoOrden/${idTurno}/${flgTiempoEspera}`)
        .then((resp) => {
          dispatch({ type: ESTADO_ORDEN_SUCCESS, payload: resp.data });
          if (nextStep) nextStep(resp.data, true);
        })
        .catch((err) => {
          dispatch({ type: ESTADO_ORDEN_FAIL, payload: err?.response?.data });
          if (nextStep) nextStep(err, false);
        });
    });
  };

export const wsUpdateUsuarioAltaOrden =
  (idTurno, autoCheck, nextStep) => (dispatch) => {
    dispatch({ type: USUARIOALTA_ORDEN });

    axiosLogin().then((respuesta) => {
      respuesta
        .put(`/his/turnos/actualizarUsuarioAlta/${idTurno}/${autoCheck}`)
        .then((resp) => {
          dispatch({ type: USUARIOALTA_ORDEN_SUCCESS, payload: resp.data });
          if (nextStep) nextStep(resp.data, true);
        })
        .catch((err) => {
          dispatch({ type: USUARIOALTA_ORDEN_FAIL, payload: err?.response?.data });
          if (nextStep) nextStep(err, false);
        });
    });
  };

// Busca órdenes digitales pendientes del paciente que matcheen con la prestación del turno.
export const wsGetMatchOrdenTurno = (idTurno, nextStep) => (dispatch) => {
  dispatch({ type: MATCH_ORDEN_TURNO });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/ordenes-digitales/match-turno/${idTurno}`)
      .then((resp) => {
        dispatch({ type: MATCH_ORDEN_TURNO_SUCCESS, payload: resp.data });
        if (nextStep) nextStep(true, resp.data);
      })
      .catch((err) => {
        dispatch({ type: MATCH_ORDEN_TURNO_FAIL, payload: err?.response?.data });
        if (nextStep) nextStep(false, err);
      });
  });
};

// Asocia una o varias órdenes digitales pendientes al turno indicado.
export const wsAsociarOrdenTurno =
  (idTurno, idsOrdenes, nextStep) => (dispatch) => {
    dispatch({ type: ASOCIAR_ORDEN_TURNO });
    axiosLogin().then((respuesta) => {
      respuesta
        .post(`/his/ordenes-digitales/asociar-turno`, {
          idTurno,
          idsOrdenes,
        })
        .then((resp) => {
          dispatch({ type: ASOCIAR_ORDEN_TURNO_SUCCESS, payload: resp.data });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({
            type: ASOCIAR_ORDEN_TURNO_FAIL,
            payload: err?.response?.data,
          });
          if (nextStep) nextStep(false, err);
        });
    });
  };
